import React,{useState} from 'react'
import {Row} from 'react-bootstrap'

import UczestnikInfo from '../Konkursy/Uczestnicy/uczestnik_informacja'
import KonkursInfo from "../Konkursy/konkurs_informacja"
import Pytanie from '../Pytania/pytanie'
import Lista from './lista'
import BladLog from './BladLogowania'

const ListaPytan  = () => {
   const [indexP,setIdP] = useState(0)

   const funk_zm_index = (index) => {
      setIdP(index)
   }
   const token = sessionStorage.getItem('token')
        return(
        <Row>
                 {!token ? <BladLog/> :
        <Row>
        <Row><UczestnikInfo/></Row>    
        <Row><KonkursInfo/></Row>
                <Row className='napis'>
                    <Lista index={indexP}/>  
                </Row>
                <Row>
                    <Pytanie index = {indexP} zmianaIndex = {funk_zm_index}/>
                </Row>
            </Row> 
                }
           </Row>      
        )
}

export default ListaPytan
